import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b25c368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-result-numbers-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " Page " + _toDisplayString(_ctx.pageNumber) + " of " + _toDisplayString(_ctx.numResults) + " result" + _toDisplayString(_ctx.s), 1))
}